import * as React from "react";
const HeadingThreeSmall = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6 5H5v4h5V5H9V4h3v1h-1v9h1v1H9v-1h1v-4H5v4h1v1H3v-1h1V5H3V4h3v1Zm9 5a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-2v-1h2v-1h-1v-1h1v-1h-2v-1h2Z" }));
HeadingThreeSmall.displayName = "HeadingThreeSmall";
var HeadingThreeSmall_default = HeadingThreeSmall;
export {
  HeadingThreeSmall_default as default
};
